import client from '@onpace/onspace-core/components/client'
import OnspaceDialog from '@onpace/onspace-core/elements/dialog'
import { showNotification } from '@onpace/onspace-core/elements/notification'

const CHANGELOG_CHECK_PATH = '/onspace/cms/changelog/check'

let hasCheckedChangelog = false
let hasUnreadItems = false

document.addEventListener('turbo:load', async (_event) => {
  if (!hasCheckedChangelog) {
    if (document.querySelector('meta[name="onspace-authenticated"]')) {
      const response = await client.get(CHANGELOG_CHECK_PATH)
      if (response.isSuccess) {
        const content = await response.content()
        hasUnreadItems = content.has_unread

        if (content.notification) {
          displayChangelogNotification(content.notification)
        }
      }

      hasCheckedChangelog = true
    }
  }

  if (hasUnreadItems) {
    const elements = document.querySelectorAll('[data-onspace-cms-changelog]')
    elements.forEach(updateChangelogElement)
  }
})

////////// UI

/// Updates a changelog link or button to indicate that there are new changelog items.
function updateChangelogElement(element) {
  const elementIcon = SVGElement.createOnspaceSpritemapSvg('onspace/icon_stars')
  elementIcon.style.color = 'var(--color-red)'
  element.appendChild(elementIcon)

  const dropdown = element.closest('drop-down')
  if (dropdown) {
    const anchor = dropdown.querySelector(':scope > a')
    if (anchor) {
      let dropdownIcon = anchor.querySelector('svg')
      if (dropdownIcon) {
        dropdownIcon.setOnspaceSpritemapSvg('onspace/icon_stars')
      } else {
        dropdownIcon = SVGElement.createOnspaceSpritemapSvg('onspace/icon_stars')
        anchor.appendChild(dropdownIcon)
      }
    }
  }
}

/// Displays a notification overlay indicating that there are new changelog items.
function displayChangelogNotification(options) {
  showNotification({
    title: options.title,
    prompt: options.prompt,
    timeout: false,
    onPress: () => {
      const element = document.querySelector('a[href][data-onspace-cms-changelog]')
      const dialog = new OnspaceDialog()
      dialog.loadUrl(element.href)
      document.body.appendChild(dialog)
    }
  })
}
